export type IRateLabelName = 'bytes' | 'long1' | 'long2' | 'sec' | 'short' | 'si' | 'symbol';

type IRateLabels = {
    [key in IRateLabelName]: Array<string>;
};

export const rateLabels: IRateLabels = {
    bytes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    long1: [
        '',
        'thousand',
        'million',
        'billion',
        'trillion',
        'quadrillion',
        'quintillion',
        'sextillion',
        'septillion',
        'octillion',
        'nonillion',
    ],
    long2: [
        '',
        'thousand',
        'thousand million',
        'billion',
        'thousand billion',
        'trillion',
        'thousand trillion',
        'quadrillion',
        'thousand quadrillion',
        'quintillion',
    ],
    short: ['', 'K.', 'mln.', 'bln.', 'trln.', 'qudln.', 'qutln.', 'sxtln.', 'septln.', 'octln.', 'nonln.'],
    sec: ['sec', 'min', 'hour'],
    si: ['', 'kilo-', 'mega-', 'giga-', 'tera-', 'peta-', 'exa-', 'zetta-', 'yotta-'],
    symbol: [
        '',
        'thousand',
        'million',
        'billion',
        'trillion',
        'quadrillion',
        'quintillion',
        'sextillion',
        'septillion',
    ],
};
